module.exports = __webpack_public_path__ + "img/KEN.381e9bfd.svg";